import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import {PaymentMethodProps} from '../types';
import paymentMethodsKeys from '../util/payment-methods-keys';

export interface CreatePaymentMethodProps
  extends Omit<PaymentMethodProps, 'id'> {}

const useCreatePaymentMethod = () => {
  const {create} = useInfiniteQueryHelpers();

  const onSuccess = (data: PaymentMethodProps) =>
    create(paymentMethodsKeys.list(), data);

  return useApiMutation<PaymentMethodProps>({
    url: '/payment-methods',
    method: 'POST',
    errorTitle: 'Erro ao cadastrar forma de pagamento',
    successTitle: 'Cadastrar forma de pagamento',
    successMessage: 'Forma de pagamento cadastrada com sucesso',
    redirectUrl: '/settings/payment-methods',
    onSuccess,
  });
};

export default useCreatePaymentMethod;
